import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    createLabRegistration as createLabRegistrationApi,
    updateLabRegistration as updateLabRegistrationApi,
    getAllLabRegistration as getAllLabRegistrationApi,
    getLabRegistration as getLabRegistrationApi,
} from './api';

// actions
import { labRegistrationApiResponseSuccess, labRegistrationApiResponseError } from './actions';

// constants
import { LabRegistrationActionTypes } from './constants';

type LabRegistrationData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Lab Registration
 * @param {*} payload
 */
function* AddLabRegistration({ payload, type }: LabRegistrationData): SagaIterator {
    try {
        const response = yield call(createLabRegistrationApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                labRegistrationApiResponseSuccess(
                    LabRegistrationActionTypes.ADD_LAB_REGISTRATION,
                    data,
                    'Lab Registration has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Lab Registration!`;
            if (message) msg = message;
            yield put(
                labRegistrationApiResponseSuccess(
                    LabRegistrationActionTypes.ADD_LAB_REGISTRATION,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            labRegistrationApiResponseError(
                LabRegistrationActionTypes.ADD_LAB_REGISTRATION,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Edit Lab Registration
 * @param {*} payload
 */
function* EditLabRegistration({ payload, type }: LabRegistrationData): SagaIterator {
    try {
        const response = yield call(updateLabRegistrationApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                labRegistrationApiResponseSuccess(
                    LabRegistrationActionTypes.EDIT_LAB_REGISTRATION,
                    data,
                    'Lab Registration Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Lab Registration!`;
            if (message) msg = message;
            yield put(
                labRegistrationApiResponseSuccess(
                    LabRegistrationActionTypes.EDIT_LAB_REGISTRATION,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            labRegistrationApiResponseError(
                LabRegistrationActionTypes.EDIT_LAB_REGISTRATION,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Fetch Lab Registration
 * @param {*} payload
 */
function* GetLabRegistration({ payload, type }: LabRegistrationData): SagaIterator {
    try {
        const response = yield call(getLabRegistrationApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                labRegistrationApiResponseSuccess(
                    LabRegistrationActionTypes.GET_LAB_REGISTRATION,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Lab Registration!`;
            if (message) msg = message;
            yield put(
                labRegistrationApiResponseSuccess(
                    LabRegistrationActionTypes.GET_LAB_REGISTRATION,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            labRegistrationApiResponseError(
                LabRegistrationActionTypes.GET_LAB_REGISTRATION,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

/**
 * Fetch Lab Registrations
 * @param {*} payload
 */
function* GetLabRegistrations({ payload, type }: LabRegistrationData): SagaIterator {
    try {
        const response = yield call(getAllLabRegistrationApi, payload);
        const { data, message, success, code } = response.data;
        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                labRegistrationApiResponseSuccess(
                    LabRegistrationActionTypes.GET_LAB_REGISTRATIONS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Lab Registration Listing!`;
            if (message) msg = message;
            yield put(
                labRegistrationApiResponseSuccess(
                    LabRegistrationActionTypes.GET_LAB_REGISTRATIONS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            labRegistrationApiResponseError(
                LabRegistrationActionTypes.GET_LAB_REGISTRATIONS,
                [],
                error,
                404,
                true,
                false
            )
        );
    }
}

export function* watchGetLabRegistration() {
    yield takeEvery(LabRegistrationActionTypes.GET_LAB_REGISTRATION, GetLabRegistration);
}

export function* watchAddLabRegistration() {
    yield takeEvery(LabRegistrationActionTypes.ADD_LAB_REGISTRATION, AddLabRegistration);
}

export function* watchEditLabRegistration(): any {
    yield takeEvery(LabRegistrationActionTypes.EDIT_LAB_REGISTRATION, EditLabRegistration);
}

export function* watchGetLabRegistrations(): any {
    yield takeEvery(LabRegistrationActionTypes.GET_LAB_REGISTRATIONS, GetLabRegistrations);
}

function* labRegistrationSaga() {
    yield all([
        fork(watchGetLabRegistration),
        fork(watchAddLabRegistration),
        fork(watchEditLabRegistration),
        fork(watchGetLabRegistrations),
    ]);
}

export default labRegistrationSaga;
